import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

export type ViewMode = 'grid' | 'list';

@Component({
  selector: 'educare-view-mode-toggle',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatTooltipModule, TranslateModule],
  templateUrl: './view-mode-toggle.component.html',
  styleUrls: ['./view-mode-toggle.component.scss']
})
export class ViewModeToggleComponent {
  @Input() viewMode: ViewMode = 'list';
  @Output() viewModeChange = new EventEmitter<ViewMode>();

  onToggle(mode: ViewMode): void {
    this.viewMode = mode;
    this.viewModeChange.emit(mode);
  }
}
